import React from 'react'

import {
  HOMEPAGE_FIELDS,
  LOCAL_BUSINESS_FIELDS,
  PAGE_META_FIELDS,
} from '../../constants/fieldGroups.constant'
import typeConstant from '../../constants/types.constant'
import AbstractCollection from '../Abstract/AbstractCollection'

// Phase 6 — listing view for `type: 'faq'` docs (the FAQs page Q&A pairs).
// Question = Name / Name Ar, answer = Content / Content Ar (Quill), display
// sequence = Order. FAQs carry no media and no page metadata, so everything
// else is hidden. Slide fields are listed individually because SLIDE_FIELDS
// includes `order`, which FAQs DO need.
const Faqs = function () {
  return (
    <AbstractCollection
      collectionName="Faqs"
      singleCollectionName="Faq"
      notToShow={[
        'ancestorIds',
        'parentId',
        'type',
        'featured',
        'coverPhoto',
        'coverImageAlt',
        'coverImageAltAr',
        'images',
        'videos',
        'title',
        'titleAr',
        'publishedAt',
        'scheduledFor',
        'heading',
        'headingAr',
        'subheading',
        'subheadingAr',
        'ctaLabel',
        'ctaLabelAr',
        'ctaUrl',
        ...PAGE_META_FIELDS,
        ...HOMEPAGE_FIELDS,
        ...LOCAL_BUSINESS_FIELDS,
      ]}
      toShow={['name', 'order', 'status', 'createdAt']}
      type={typeConstant.FAQ}
    />
  )
}
export default Faqs
